<template>
	<div>
		<base-header v-once pageName="메모하기" :popup="true"></base-header>
		<section id="wrap">
			<div class="memo-Wrap">
				<p>
					<em :class="gubun | jicClass"></em>
					<strong>{{name}}</strong>
					<span>{{targetId}}</span>
				</p>
					
				<div class="memo-input">
					<textarea name="" placeholder="메모 내용을 입력해주세요." :value="contents" v-on:input="contents = $event.target.value"></textarea>
					<span><em>{{txtSize}}</em>/1000Byte</span>
				</div>
			</div>
		</section>
		<div class="btnWrap">
			<button type="button" class="red" @click="saveMemo">{{bhvrTxt}}하기</button>
		</div>
	</div>
</template>

<script>
export default {
	name: "OrgnzMemo",
	data() {
		return{
			sqno : '',
			targetId : '',
			gubun : '',
			name : '',
			contents : '',
			txtSize : 0,
			bhvrTxt : '등록'
		};
	},watch: {
		contents(newVal, oldVal){
			var byte = 0;

			for (var i=0; i<newVal.length; ++i) {
				(newVal.charCodeAt(i) > 127) ? byte += 2 : byte++ ;
			}

			if(byte > 1000)
				this.contents = oldVal;
			else
				this.txtSize = byte;
		}
	},methods:{
		close: function() {
			this.$utils.nativeIf.outbound.close();
		},
		saveMemo: function(){
			if(!this.contents || !this.contents.trim()){
				alert("내용을 입력해주세요.");
				return false;
			}

			if(confirm("메모를 "+this.bhvrTxt+"하시겠습니까?")){
				var that = this;
				var parameters = {
					sqno : this.sqno,
					targetId : this.targetId,
					contents : this.contents,
				};
				this.$api.orgnz
				.memoSave(parameters)
				.then(function(data) {
					if(data && data > 0){
						alert(that.bhvrTxt+"되었습니다.");

						var child = {
							name: "orgnz-memo-refresh",
							data: true
						};
						that.$utils.nativeIf.outbound.sendChildData(child);
					}else{
						alert(that.bhvrTxt+"에 실패하였습니다.");
					}
				})
				.catch(function(error) {
						alert(error.rtMsg);
				});
			}
		}
	},
	filters:{
		jicClass:function(gubun){
			var clss = "";
			
			if(gubun == 'COG01'){
				clss = "epLv";
			}else if(gubun == 'COG02'){ 
				clss = "epLv1";
			}else if(gubun == 'COGA2'){ 
				clss = "epLvA1";
			}else if(gubun == 'COG03'){ 
				clss = "epLv2";
			}else if(gubun == 'COG04'){
				clss = "epLv3";
			}else if(gubun == 'COG05'){
				clss = "epLv4";
			}else if(gubun == 'COG06'){
				clss = "epLv5";
			}

			return clss;
		}
	},
	created : function(){
		var parent = this.$store.getters.parent;
		if(parent.name == 'orgnz-target-memo'){
			
			this.targetId = parent.data.targetId
			this.gubun = parent.data.gubun
			this.name = parent.data.name

			if(parent.data.sqno){
				this.bhvrTxt = '수정'
				this.sqno = parent.data.sqno
				this.contents = parent.data.contents
				
			}
		}
	}
}
</script>
